import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

/** Every control is a Select or a Switch held in hook state, so there is nothing to validate. */
export const commLogWritebackValidator = withZod(z.object({}))
